export default __webpack_public_path__ + "static/media/disabled-btn.85d0afa2.svg";